import { SET_USER, FETCH_ALL_USERS, VERIFY_USER,SET_AUTH_INFO,GET_ALL_EXT_USERS } from "../actionTypes";

const defaultState = {
  all: [],
  allExtUser:[],
  currentUser: {},
  authInfo:{}
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_ALL_USERS:
      return { ...state, all: action.payload };
    case SET_USER:
      return { ...state, currentUser: action.payload };
    case VERIFY_USER:
      return { ...state, currentUser: action.payload };
    case SET_AUTH_INFO:
        return { ...state, authInfo: action.payload };
    case GET_ALL_EXT_USERS:
        return { ...state, allExtUser: action.payload };    
    default:
      return state;
  }
};
